import { render, staticRenderFns } from "./KaijuAddFundsForm.vue?vue&type=template&id=45fcfc5b&"
import script from "./KaijuAddFundsForm.vue?vue&type=script&lang=ts&"
export * from "./KaijuAddFundsForm.vue?vue&type=script&lang=ts&"
import style0 from "./KaijuAddFundsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports